module.exports = __webpack_public_path__ + "img/1-icono-nuevo-tramite.5a4aefd4.svg";